import {getStartObject} from '../config/startObject';
import Track from '../utils/tracking';

const LanguageSource = {
  defaultLang: () => {
    const startObject = getStartObject();

    if (startObject && startObject.hasOwnProperty('translations')) {
      return startObject.translations;
    }

    Track.warn('startObj or startObj.translations missing');
    return {};
  },
};

export default LanguageSource;
